import * as React from "react";
import ServerConfigStep, { STEP_KEY as SERVER_CONFIG_KEY } from "./ServerConfigStep";
import UserSyncStep, { STEP_KEY as USER_SYNC_KEY } from "./UserSyncStep";
import GroupSyncStep, { STEP_KEY as GROUP_SYNC_KEY } from "./GroupSyncStep";
import StepTitleWarning from "./StepTitleWarning";
const wizardSteps = ({
  formRefs,
  handleSubmitAll,
  help,
  excludedFields,
  invalidStepKeys,
  prepareSubmitPayload,
  roles,
  setActiveStepKey,
  submitAllError
}) => [
  {
    key: SERVER_CONFIG_KEY,
    title: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StepTitleWarning, { invalidStepKeys, stepKey: SERVER_CONFIG_KEY }), "Server Configuration"),
    component: /* @__PURE__ */ React.createElement(
      ServerConfigStep,
      {
        formRef: formRefs[SERVER_CONFIG_KEY],
        help,
        onSubmit: () => setActiveStepKey(USER_SYNC_KEY),
        onSubmitAll: handleSubmitAll,
        submitAllError,
        validateOnMount: invalidStepKeys.includes(SERVER_CONFIG_KEY)
      }
    )
  },
  {
    key: USER_SYNC_KEY,
    title: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StepTitleWarning, { invalidStepKeys, stepKey: USER_SYNC_KEY }), "User Synchronization"),
    component: /* @__PURE__ */ React.createElement(
      UserSyncStep,
      {
        formRef: formRefs[USER_SYNC_KEY],
        help,
        excludedFields,
        onSubmit: () => setActiveStepKey(GROUP_SYNC_KEY),
        onSubmitAll: handleSubmitAll,
        roles,
        submitAllError,
        validateOnMount: invalidStepKeys.includes(USER_SYNC_KEY)
      }
    )
  },
  {
    key: GROUP_SYNC_KEY,
    title: /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StepTitleWarning, { invalidStepKeys, stepKey: GROUP_SYNC_KEY }), "Group Synchronization (Opt.)"),
    component: /* @__PURE__ */ React.createElement(
      GroupSyncStep,
      {
        formRef: formRefs[GROUP_SYNC_KEY],
        help,
        excludedFields,
        onSubmitAll: handleSubmitAll,
        prepareSubmitPayload,
        roles,
        submitAllError,
        validateOnMount: invalidStepKeys.includes(GROUP_SYNC_KEY)
      }
    )
  }
];
export default wizardSteps;
